export default "__VITE_ASSET__369120c0__"